<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-top: 1.5em; font-size:150%"><a id="toc"></a></div>
<h4 class="fronthead2">CONTENTS</h4>
<p> </p>
<p class="toc" style="margin-top: 0"><a href="#/html/06_c1#c1" id="tc1">MEMORANDUM OF HENRY SEQUERRA</a></p>
<p class="toc"><a href="#/html/07_c2#c2" id="tc2">NARRATIVE OF DR PHILIP ARDOWER</a></p>
<p class="toc"><span href="#/html/08_c3#c3" id="tc3" title="Link target outside of Sample">MY INTERVENTION</span></p>
<p class="toc"><span href="#/html/09_c4#c4" id="tc4" title="Link target outside of Sample">NARRATIVE OF OLURA MANOLI</span></p>
<p class="toc"><span href="#/html/10_c5#c5" id="tc5" title="Link target outside of Sample">MY COMMENTS</span></p>
<p class="toc"><span href="#/html/11_c6#c6" id="tc6" title="Link target outside of Sample">CONTINUATION OF DR ARDOWER’S NARRATIVE</span></p>
<p class="toc"><span href="#/html/12_c7#c7" id="tc7" title="Link target outside of Sample">SECRET AND PERSONAL</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_toc.vue?725893a9